export const DATA_KEY_IS_SCALED = "mpse__transform__model__const__is_scaled";
export const DATA_KEY_IS_INIT_TRANSFORM = `mpse__transform__model__const__is_init_transform`;
